<button
  #pill
  type="button"
  class="inline-flex items-center gap-1.5 h-7 px-3 rounded-full border-0 cursor-pointer text-caption font-medium"
  [class]="anonymized() ? 'bg-mint-10 text-finserv-100' : 'bg-neutral-5 text-warning-100'"
  [attr.aria-expanded]="isOpen()"
  aria-haspopup="dialog"
  (click)="toggle()"
>
  <!-- `lock` is not in the icon map; the keyhole lock stands in for it. -->
  <span class="fa-icons icon-solid icon-12 icon-lock-keyhole" aria-hidden="true"></span>
  <span class="fa-icons icon-solid icon-12 icon-shield-check" aria-hidden="true"></span>
  <span class="fa-icons icon-solid icon-12 icon-database" aria-hidden="true"></span>
  <span class="whitespace-nowrap">{{ statusKey() | translate }}</span>
  <span
    class="fa-icons icon-solid icon-10"
    [class]="isOpen() ? 'icon-chevron-down' : 'icon-chevron-up'"
    aria-hidden="true"
  ></span>
</button>

@if (isOpen()) {
  <kendo-popup
    [anchor]="pill"
    [anchorAlign]="{ horizontal: 'left', vertical: 'top' }"
    [popupAlign]="{ horizontal: 'left', vertical: 'bottom' }"
    [margin]="{ horizontal: 0, vertical: 8 }"
    (outsideClick)="close()"
    (anchorViewportLeave)="close()"
  >
    <!-- static, m-0, border-0 and bg-transparent undo the browser's own dialog styles. -->
    <dialog
      open
      [attr.aria-label]="statusKey() | translate"
      class="w-[190px] p-3 flex flex-col gap-3 text-body-2 text-black static m-0 border-0 bg-transparent"
    >
      <div class="flex items-start gap-3">
        <span
          class="fa-icons icon-solid icon-16 icon-lock-keyhole pt-0.5 shrink-0"
          [class]="anonymized() ? 'text-finserv-100' : 'text-warning-100'"
          aria-hidden="true"
        ></span>
        <span>{{ anonymizerKey() | translate }}</span>
      </div>
      <div class="flex items-start gap-3">
        <span
          class="fa-icons icon-solid icon-16 icon-shield-check text-finserv-100 pt-0.5 shrink-0"
          aria-hidden="true"
        ></span>
        <span>{{ residencyKey() | translate }}</span>
      </div>
      <div class="flex items-start gap-3">
        <span
          class="fa-icons icon-solid icon-16 icon-database text-finserv-100 pt-0.5 shrink-0"
          aria-hidden="true"
        ></span>
        <span>{{ sourceKey() | translate }}</span>
      </div>
    </dialog>
  </kendo-popup>
}
